import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';


@Component({
  selector: 'app-cyber-lab-services',
  templateUrl: './cyber-lab-services.component.html',
  styleUrls: ['./cyber-lab-services.component.css']
})
export class CyberLabServicesComponent implements OnInit {

  heading = "Cyber Lab Services";
  subheading = "Each data that is stored and used in Cyberspace is at risk. With the advent of rapid technology adoption, high is the cyber threats and attacks for many organizations. Protectt.ai provide a cohesive and integrated approach to protect and safeguard business data";
  innerWidth:number = window.innerWidth;

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta,  private canonicalService: CanonicalService) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/cyber-lab-services");
   }

  ngOnInit(): void {
    this.titleService.setTitle('Cyber Lab Services | Cyber Security Services | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: "Cyber Security Services & Applications for Mobie Devices | Protectt.ai"});
    this.metaTagService.updateTag(
      { name: 'description', content: 'Protectt.ai provide a cohesive and integrated approach to protect and safeguard business data. We managed security services helps organizations to deal with cyber issues.' }
    );
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
